import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getPresetRange } from '../utils/dateRangePresets';

const SaudiDateFilterContext = createContext(null);

export function SaudiDateFilterProvider({ children }) {
  const [preset, setPreset] = useState('this_month');
  const [range, setRange] = useState(() => getPresetRange('this_month'));

  const onPresetChange = useCallback((nextPreset, nextRange) => {
    setPreset(nextPreset);
    setRange(nextRange);
  }, []);

  const value = useMemo(
    () => ({ preset, range, onPresetChange }),
    [preset, range, onPresetChange]
  );

  return (
    <SaudiDateFilterContext.Provider value={value}>
      {children}
    </SaudiDateFilterContext.Provider>
  );
}

export function useSaudiDateFilter() {
  const ctx = useContext(SaudiDateFilterContext);
  if (!ctx) {
    throw new Error('useSaudiDateFilter must be used within SaudiDateFilterProvider');
  }
  return ctx;
}

export default SaudiDateFilterContext;
